import React from 'react';
import PropTypes from 'prop-types';
import { getConfig } from '@edx/frontend-platform';
import { FormattedMessage, injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import messages from './messages';

function OutlineBreadcrumbs({
  courseId,
  intl,
}) {

  return (
    <nav
      aria-label={intl.formatMessage(messages.OutlineBreadcrumbsMessage)}
      className="my-4 px-0 d-inline-block col-sm-10">
      <ol className="px-0 course-breadcrumbs d-flex flex-wrap align-items-center m-0">
        <li className="d-flex m-0">
          <a
            className="flex-shrink-0 font-weight-bold"
            href={`${getConfig().LMS_BASE_URL}/dashboard`}
          >
            <FontAwesomeIcon icon={faHome} className="mr-2" />
            <FormattedMessage
              id="learn.breadcrumb.navigation.course.my.courses"
              description="Button to redirect user to their course dashboard"
              defaultMessage="My Courses"
            />
          </a>
        </li>
        <li className="mx-2 text-truncate text-nowrap" role="presentation" aria-hidden>/</li>
        <li className="d-flex m-0">
          <Link
            to={`/course/${courseId}/home`}
          >
            <FormattedMessage
              id="learn.breadcrumb.navigation.course.home"
              description="The course home link in breadcrumbs nav"
              defaultMessage="Course"
            />
          </Link>
        </li>
      </ol>
    </nav>
  );
}

OutlineBreadcrumbs.propTypes = {
  courseId: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(OutlineBreadcrumbs)